import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Reveal } from "./Reveal";
import { Flame } from "lucide-react";

export const srcOf = (f) =>
  f.image_src?.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${f.image_src}` : f.image_src;

export default function FavoritesSection() {
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    api.get("/favorites").then((r) => setFavorites(r.data)).catch(() => {});
  }, []);

  if (!favorites.length) return null;

  return (
    <section id="coups-de-coeur" data-testid="favorites-section" className="py-20 md:py-28 bg-[#F4EFEA]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mb-12 flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-[#C85A32] mb-4">Les coups de cœur du mois</p>
            <h2 className="font-display tracking-tight text-[#201815] text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Sorties du four,
              <br />
              <span className="italic text-[#C85A32]">fraîchement émaillées.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm text-[#8A7971] leading-relaxed flex items-start gap-2">
            <Flame size={16} className="text-[#C85A32] shrink-0 mt-0.5" />
            Chaque mois, une sélection de pièces créées à l'atelier par nos clients. La vôtre sera peut-être la prochaine.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {favorites.map((f, i) => (
            <Reveal key={f.id} delay={i * 0.08}>
              <figure data-testid={`favorite-card-${i}`} className="group">
                <div className="overflow-hidden rounded-2xl border-[5px] border-white shadow-[0_20px_40px_-20px_rgba(32,24,21,0.25)]">
                  <img
                    src={srcOf(f)}
                    alt={f.title || "Pièce émaillée réalisée à l'atelier"}
                    className="w-full h-80 object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <figcaption className="mt-4 px-1">
                  <p className="font-display text-xl text-[#201815]">{f.title}</p>
                  {f.description && <p className="text-sm text-[#8A7971] mt-1">{f.description}</p>}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
